export default __webpack_public_path__ + "empty-epic-md.7978cef8.svg";